// To the Top & Sticky Menu

const showMenu = document.querySelector('#nav');
const toTop = document.querySelector('#tothetop');

toTop.addEventListener('click', () => {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
});

window.onscroll = () => {
  const scroll = window.scrollY;
  showScrollTop(scroll);
};

function showScrollTop(scroll) {
  // In the case that the scroll is greater than 500 add some classes
  if (scroll > 600) {
      showMenu.classList.add("sticky");
      toTop.classList.add("to-top");
  } else {
    showMenu.classList.remove("sticky");
    toTop.classList.remove("to-top");
  }
}